import PriceButton from 'components/Price/Button/styled';

export default PriceButton;
